// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle-module--subtitle--1HgiU","subtitleSmall":"Subtitle-module--subtitle--small--3AcRv","subtitleBig":"Subtitle-module--subtitle--big--iLOaN"};